import React from "react";
import { Route, Switch } from "react-router-dom";

import ExceptionPage from "./exception/ExceptionPage";
import NietGevondenPage from "./notFound/NietGevondenPage";
import ParentHistoryComponent from "./common/ParentHistoryComponent";
import TestPage from "./TestPage";

import DemoPage from "./demo/DemoPage";
import ExterneKlachtenPage from "./klachten/ExterneKlachtenPage";
import InterneKlachtenPage from "./klachten/InterneKlachtenPage";
import MeldingenPage from "./meldingen/MeldingenPage";

import SportenOpHetWerkPage from "./sportenophetwerk/SportenOpHetWerkPage";
export const getRoutes = (match) => {

	return (
		<Switch>
			<Route path={`${match.url}/demo`} component={DemoPage} />
			<Route path={`${match.url}/:accountId/demo/new`} render={(props) => <DemoPage {...props} isNew />} />

			<Route path={`${match.url}/externeKlachten`} component={ExterneKlachtenPage} />
			<Route path={`${match.url}/interneKlachten`} component={InterneKlachtenPage} />
			<Route path={`${match.url}/meldingen`} component={MeldingenPage} />

			<Route path={`${match.url}/sportenOpHetWerk`} component={SportenOpHetWerkPage} />

			<Route path={`${match.url}/parentHistory/back`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/parentHistory/path`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/exception`} component={ExceptionPage} />

			<Route exact path={`${match.url}`} component={TestPage} />
			<Route exact path={`${match.url}/`} component={TestPage} />
			<Route path={`${match.url}/*`} component={NietGevondenPage} />

		</Switch>
	);
};
